import { isFeatureEnabled } from 'owa-feature-flags';
import { makePutRequest } from 'owa-ows-gateway';
import { ActivityStateFlags } from './ActivityFeedStorageItem';
import { updateActivityFeedState } from './updateActivityFeedState';

const MARK_ITEMS_SEEN_URL: string = 'ows/v1.0/ActivityFeed/MarkItemsAsSeen';

export async function markItemsAsSeen(items: string[], resetUnseenCount: boolean): Promise<void> {
    if (items.length === 0 && !resetUnseenCount) {
        return;
    }

    if (isFeatureEnabled('auth-activityFeedV2Schema')) {
        updateActivityFeedState(
            items,
            ActivityStateFlags.IsSeen,
            ActivityStateFlags.None,
            resetUnseenCount
        );
    } else {
        makePutRequest(MARK_ITEMS_SEEN_URL, items);
    }
}
